import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

export default function HeroSlider() {
    const slides = [
        "/images/slider_bank_front.webp",
        "/images/slider_bank_front_2.webp"
    ];

    return (
        <section className="w-full relative">
            <Swiper
                modules={[Autoplay]}
                spaceBetween={0}
                slidesPerView={1}
                loop={true}
                autoplay={{ delay: 5000 }}
            >
                {slides.map((img, i) => (
                    <SwiperSlide key={i}>
                        <img 
                            src={img} 
                            alt={`Slide ${i + 1}`} 
                            className="w-full h-auto block" 
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
}

